// reportsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ReportService } from '../../services/ReportService';

// Async thunk for fetching reports
export const fetchReports = createAsyncThunk(
  'reports/fetchReports',
  async ({ keyid, additionalParams } ) => {
    const response = await ReportService.getObjects(keyid, additionalParams);
    return response;
  }
);

const reportsSlice = createSlice({
  name: 'reports',
  initialState: {
    data: [],
    totalRows: 0,
    isLoading: false,
    error: null,
  },
  reducers: {
    // Update feedback for a specific report by evaluation_id
    updateReportFeedback: (state, action) => {
      const { evaluationId, feedbackValue } = action.payload;
      const reportIndex = state.data.findIndex(
        (report) => report.evaluation_id === evaluationId
      );
      
      if (reportIndex !== -1) {
        // Update the feedback value for the specific report
        state.data[reportIndex].feedback = feedbackValue;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReports.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchReports.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.map((item) => item);
        state.totalRows = action.payload?.count || 0;
      })
      .addCase(fetchReports.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

// Export action creators
export const { updateReportFeedback } = reportsSlice.actions;

export default reportsSlice.reducer;